export default __webpack_public_path__ + "static/media/teacher_student.4bec67b4.png";